import React from "react";

const Tag = ({
  title,
  size = "md",
  color = "primary", // primary, warning, success, danger, black, white
  variant = "contained", // contained, outlined, text
  className = "",
}) => {
  const sizeStyles = {
    xs: "text-[9px] leading-none p-1",
    "xs-sm": "text-[10px] leading-none p-1",
    sm: "text-[12px] leading-none p-2",
    md: "text-[14px] leading-none p-2",
    lg: "text-[16px] leading-none p-2",
    xl: "text-[18px] leading-none  p-2",
  };

  const colors = {
    primary: {
      contained: "bg-primary text-white border border-primary",
      outlined: "border border-primary text-primary",
      text: "text-primary",
    },
    warning: {
      contained: "bg-warning text-white border border-warning",
      outlined: "border border-warning-100 text-warning",
      text: "text-warning",
    },
    success: {
      contained: "bg-success text-white border border-success",
      outlined: "border border-success-100 text-success",
      text: "text-success",
    },
    danger: {
      contained: "bg-danger text-white border border-danger",
      outlined: "border border-danger-100 text-danger",
      text: "text-danger",
    },
    info: {
      contained: "bg-info text-white border border-info",
      outlined: "border border-info-100 text-info",
      text: "text-info",
    },
    black: {
      contained: "bg-black text-white border border-black",
      outlined: "border border-black text-black",
      text: "text-black",
    },
    white: {
      contained: " bg-neutrals-50 text-black border border-neutrals-50",
      outlined: "border border-gray-300 text-gray-700",
      text: "text-gray-700",
    },
  };

  return (
    <div
      className={`body-two rounded  flex justify-center items-center ${sizeStyles[size]} ${colors[color]?.[variant]} ${className}`}
    >
      {title}
    </div>
  );
};

export default Tag;
